import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b6bc292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-left fs-2 fw-bold mt-3 ms-2" }, "■グレード情報検索結果", -1 /* HOISTED */))
const _hoisted_3 = { class: "container rounded-3 mb-2" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "horizon mt-3 mb-3" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-left-note" }, [
  /*#__PURE__*/_createTextVNode(" 該当するグレード情報はございません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 入力した車台番号に誤りがないか、再度ご確認をお願いします。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" グレード情報が得られない場合は、以下よりお問い合わせ用紙をダウンロードいただき、FAXにてお問い合わせください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご提供できる情報であれば、回答させていただきます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 回答までに多少のお時間をいただくことがございますのであらかじめご了承ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" なお、FAXの受付時間は月～金（弊社休日を除く）の９：００～１１：３０、１３：００～１７：００となります。"),
  /*#__PURE__*/_createElementVNode("br")
], -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "検索ページに戻る", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-left fs-2 fw-bold mt-3 ms-2" }, "■お問い合わせ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Header"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, " 車台番号: " + _toDisplayString($setup.notFoundVinNo), 1 /* TEXT */),
      _hoisted_5,
      _hoisted_6
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary btn-position",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toSearchGrade()))
    }, _hoisted_8),
    _hoisted_9,
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        class: "fs-5 ms-3 manual-link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openPDF()))
      }, " ＦＡＸ問い合わせ用紙(ＰＤＦ) ")
    ]),
    _createVNode($setup["Footer"])
  ]))
}